import { fetchWithTimeout } from './probes/http-ping.js';

export function parseUserAgent(ua) {
  if (!ua) return { browser: 'Unknown', os: 'Unknown' };

  let browser = 'Unknown';
  if (/Edg\//.test(ua)) browser = 'Edge';
  else if (/Chrome\/[\d.]+/.test(ua) && !/Edg\//.test(ua)) browser = 'Chrome';
  else if (/Firefox\/[\d.]+/.test(ua)) browser = 'Firefox';
  else if (/Safari\/[\d.]+/.test(ua) && !/Chrome\//.test(ua)) browser = 'Safari';

  let os = 'Unknown';
  if (/Mac OS X/.test(ua)) os = 'macOS';
  else if (/Windows NT/.test(ua)) os = 'Windows';
  else if (/Linux/.test(ua)) os = 'Linux';
  else if (/Android/.test(ua)) os = 'Android';
  else if (/iPhone|iPad|iOS/.test(ua)) os = 'iOS';

  return { browser, os };
}

async function fetchPublicIp(fetchImpl = fetch, requestTimeoutMs = 4_000) {
  // ipify is unauthenticated, free-tier; if it errors we just leave the field null.
  try {
    const res = await fetchWithTimeout('https://api.ipify.org?format=json', {
      fetchImpl,
      timeoutMs: requestTimeoutMs
    });
    if (!res.ok) return null;
    const data = await res.json();
    return data?.ip || null;
  } catch {
    return null;
  }
}

async function fetchIpGeo(ip, fetchImpl = fetch, requestTimeoutMs = 4_000) {
  if (!ip) return {};
  try {
    const res = await fetchWithTimeout(`https://ipapi.co/${ip}/json/`, {
      fetchImpl,
      timeoutMs: requestTimeoutMs
    });
    if (!res.ok) return {};
    const data = await res.json();
    return {
      country: data.country_name || null,
      country_code: data.country_code || null,
      city: data.city || null,
      region: data.region || null,
      isp: data.org || null,
      asn: data.asn || null
    };
  } catch {
    return {};
  }
}

export async function captureEnvironment({ serverUrl, fetchImpl = fetch, requestTimeoutMs = 4_000 } = {}) {
  const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  const { browser, os } = parseUserAgent(ua);
  const connection = typeof navigator !== 'undefined' ? navigator.connection : null;

  const [ip, serverEnv] = await Promise.all([
    fetchPublicIp(fetchImpl, requestTimeoutMs),
    serverUrl
      ? fetchWithTimeout(`${serverUrl}/env`, {
          fetchImpl,
          timeoutMs: requestTimeoutMs
        }).then(r => r.ok ? r.json() : {}).catch(() => ({}))
      : Promise.resolve({})
  ]);
  const geo = await fetchIpGeo(ip, fetchImpl, requestTimeoutMs);

  return {
    user_agent: ua,
    browser,
    os,
    connection_type: connection?.type
      || (connection ? 'unknown_desktop' : null),
    public_ip: ip,
    detected_country: geo.country || null,
    detected_country_code: geo.country_code || null,
    detected_city: geo.city || null,
    detected_region: geo.region || null,
    detected_isp: geo.isp || null,
    detected_asn: geo.asn || null,
    via_cloudflare_tunnel: Boolean(serverEnv.via_cloudflare_tunnel),
    captured_at: new Date().toISOString()
  };
}
